import styled from 'styled-components/macro';
import Column from './Column';

export default styled(Column)`
  max-height: 80vh;
  overflow-y: auto;
`;
